<template>
  <div
    id="login"
    class="relative h-screen flex items-center justify-center overflow-x-hidden"
    :class="$i18n.locale"
  >
    <div
      class="
        shadow-md
        bg-white
        px-8
        py-6
        flex flex-col
        w-11/12
        lg:w-3/12
        md:w-5/12
        z-10
        rounded-md
        p-4
        rounded-tl-2xl rounded-tr-md rounded-br-2xl rounded-bl-md
        border-r-4 border-carpo
      "
    >
      <h2 class="font-medium text-lg text-gray-800 mb-8">
        {{ $t('LOGIN') }}
      </h2>
      <el-form
        @keyup.enter.native="submitForm('ruleForm')"
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        ref="ruleForm"
        label-width="120px"
        v-loading="loading"
        class="demo-ruleForm flex flex-col"
      >
        <el-form-item :label="$t('USERNAME')" prop="username" class="mb-2">
          <el-input
            suffix-icon="el-icon-user"
            v-model="ruleForm.username"
            class="left-inputs"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('PASSWORD')" prop="pass" class="mb-2">
          <el-input
            type="password"
            v-model="ruleForm.pass"
            autocomplete="off"
            show-password
            class="left-inputs"
          ></el-input>
        </el-form-item>

        <el-form-item class="buttonHolder mb-0">
          <div class="flex justify-end items-center">
            <!-- <ChangeLanguage /> -->
            <el-button :type="type" @click="submitForm('ruleForm')">
              {{ $t('LOGIN') }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import ChangeLanguage from '@/components/setting/ChangeLanguage.vue'
export default {
  data() {
    return {
      loading: false,
      type: 'info',
      lang: 'en',
      options: [
        {
          value: 'fa',
          label: 'فارسی',
        },
        {
          value: 'en',
          label: 'English',
        },
      ],
      ruleForm: {
        username: '',
        pass: '',
      },
      rules: {
        username: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('USERNAME'),
            }),
            trigger: 'blur',
          },
          {
            min: 3,
            message: this.$i18n.t('MIN_LENGTH', {
              type: '3',
            }),
            trigger: 'blur',
          },
        ],
        pass: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('PASSWORD'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.type = 'success'
          this.loading = true
          const actionPayload = {
            username: this.ruleForm.username.toLowerCase(),
            password: this.ruleForm.pass,
          }
          this.$store.dispatch('login', actionPayload).then((res) => {
            if (!res) {
              this.loading = false
            }
          })
        } else {
          this.type = 'info'
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    changeLang(lang) {
      // this.$i18n.locale = "en";
      // this.$router.replace({ params: { lang: lang } }).catch(() => {});
      this.$store.dispatch('changeLocale', lang)
    },
  },
  components: {
    ChangeLanguage,
  },
}
</script>
<style scoped lang="scss">
#login {
  background-image: url('~@/assets/images/newBack.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  background-position: 60% 0;
  &::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    background: #000000a3;
    z-index: 0;
  }
  .el-form-item:not(.buttonHolder) {
    margin-bottom: 40px;
  }
}
</style>
